module.exports = __webpack_public_path__ + "img/np-cover.8921d26b.webp";